import React from "react";
import { Icon } from "./Icon.jsx";

export function Chip({ children, icon, onRemove, style = {} }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6, height: "var(--h-pill)", padding: "0 8px",
      background: "var(--bg-chip)", border: "1px solid var(--line-b)", borderRadius: "var(--r-pill)",
      fontSize: "var(--fs-11)", color: "var(--fg-4)", whiteSpace: "nowrap", ...style,
    }}>
      {icon ? <Icon name={icon} size={12} /> : null}
      {children}
      {onRemove ? <span onClick={onRemove} style={{ display: "inline-flex", cursor: "pointer", color: "var(--fg-9)" }}><Icon name="x" size={11} /></span> : null}
    </span>
  );
}
